import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/events", label: "事件库" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? "border-b border-background-200 bg-background-50/95 backdrop-blur" : "bg-transparent"
      }`}
    >
      <nav className="container-x flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2" aria-label="国产吃瓜视频首页">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
            }`}
          >
            <i className="ri-fire-fill text-xl"></i>
          </span>
          <span
            className={`font-heading text-lg font-bold tracking-wide ${
              solid ? "text-foreground-900" : "text-background-50"
            }`}
          >
            吃瓜速递
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  solid
                    ? isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-900"
                    : isActive
                      ? "bg-background-50/20 text-background-50"
                      : "text-background-50/85 hover:bg-background-50/15 hover:text-background-50"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <span
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ${
              solid ? "bg-accent-100 text-accent-700" : "bg-background-50/15 text-background-50"
            }`}
          >
            <i className="ri-flashlight-fill text-xs"></i>
            每日更新
          </span>
          <Link
            to="/events"
            className={`inline-flex items-center gap-2 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
              solid
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-foreground-900 hover:bg-primary-100"
            }`}
          >
            查看热点
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <button
          type="button"
          className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
            solid ? "text-foreground-800 hover:bg-background-100" : "text-background-50 hover:bg-background-50/15"
          }`}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-4 py-2.5 text-sm font-medium ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/events"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              查看热点
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}